import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LoginUser } from 'src/app/services/webapiclient.service';
import { locale } from 'devextreme/localization';
import messagesHu from 'node_modules/devextreme/localization/messages/hu.json';
import messagesEs from 'node_modules/devextreme/localization/messages/es.json';
import { loadMessages } from 'devextreme/localization';
import { Router } from '@angular/router';
import { Role, RoleGU, RolePU, RolePUD, RoleU } from '../models/role';
import { SubscriptionService } from '../module-subscription/subscription-service';
import { Packages } from '../module-subscription/subscription-models';

@Component({
    selector: 'app-packages',
    templateUrl: './packages.component.html',
    styleUrls: ['./packages.component.scss'],
    standalone: false
})
export class PackagesComponent implements OnInit, OnDestroy {

  currentUser: LoginUser;
  packages: Packages;
  error = '';
  loading: boolean = false; dataSource: any;
  rolePU: boolean = false;
  rolePUD: boolean = false;
  roleGU: boolean = false;
  roleU: boolean = false;

  private translSubs$: Subscription;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private translation: L10nTranslationService,
    private authenticationService: AuthenticationService,
    private subscriptionService: SubscriptionService,
    private router: Router
  ) {

    const huMessages = JSON.stringify(messagesHu['hu']);
    const esMessages = JSON.stringify(messagesEs['es']);
    loadMessages({
      'hu': JSON.parse(huMessages),
      'es': JSON.parse(esMessages)
    });
    this.currentUser = this.authenticationService.currentUserValue;

  }

  ngOnInit(): void {
    this.translSubs$ = this.translation.onChange().subscribe(
      x => {
        locale(x.language);
        this.subscriptionService.getPackages(x.language).subscribe(
          (res) => {
            this.packages = <Packages>res;
          });
      });

    this.roleGU = RoleGU.includes(this.currentUser.role as Role)
    this.rolePU = RolePU.includes(this.currentUser.role as Role)
    this.rolePUD = RolePUD.includes(this.currentUser.role as Role)
    this.roleU = RoleU.includes(this.currentUser.role as Role)
  }
  ngOnDestroy() {
    if (this.translSubs$) {
      this.translSubs$.unsubscribe();
    }
  }

  onSelect(item, pud: boolean = false) {
    if (this.rolePUD || !pud) {
      this.router.navigate([item]);
    } else {
      //Nincs jogosultsága, átirányítjuk az előfizetési csomagokhoz
      this.router.navigate(['subscription/packages']);
    }
  }

}
